import { StarFilled } from "@ant-design/icons";
import { Badge, Progress, Rate, Spin } from "antd";
import PropTypes from "prop-types";
import { useContext, useState } from "react";
import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import Widget from "shared/components/templates/Widget";
import AuthContext from "shared/providers/context/AuthContext";
import Assessments from "./Assessments";
import { Container, Content } from "./styles";

const Feedback = ({ sectionTitle, hideTitle, course, reviews }) => {
  const { loggedUser } = useContext(AuthContext);
  const [rateFilter, setRateFilter] = useState(null);

  const newReviews = [];

  const {
    id: entityId,
    has_reviewed: hasReviewed,
    status_read_reviews: readStatus,
    status_write_reviews: writeStatus,
    has_enrollment: hasEnrollment,
    start_enrollment: startEnrollment,
    complete_percentage: completePercentage,
  } = course;

  const contentType = "Vico068\\CourseTools\\Course";

  const handleRateFilter = (rate, rowIndex) => {
    if (reviews.data[0]?.total[rate] !== 0) {
      setRateFilter(rate);

      const rows = document.querySelectorAll(".rate-filter-btn");
      const row = rows[rowIndex];
      row.focus();

      const feedbackSection = document.querySelector(".feedback");
      if (feedbackSection) {
        feedbackSection.scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
        window.scroll(0, 0);
      }
    }
  };

  const userCanRead =
    readStatus === "public" ||
    (readStatus === "all_logged_users" && loggedUser) ||
    (readStatus === "only_enrolled_users" && hasEnrollment && startEnrollment);

  return (
    <>
      <Container className="feedback">
        <Widget
          transparentDarkDisabled
          styleName="gx-card-tabs gx-card-tabs-right gx-card-profile"
          title={
            !hideTitle ? (
              <>
                <span className="section-title">{sectionTitle}</span>
                <Badge
                  count={reviews && reviews.meta.total + newReviews.length}
                />
              </>
            ) : (
              ""
            )
          }
        >
          <>
            {false ? (
              <div className="spin-container">
                <Spin />
              </div>
            ) : (
              <Content>
                <div className="feedback-container">
                  <div className="average-section">
                    <h1>
                      {newReviews?.length > 0
                        ? newReviews[
                            newReviews.length - 1
                          ].percentage.media.toFixed(1)
                        : reviews?.data[0]?.percentage?.media.toFixed(1) || 0}
                    </h1>

                    {newReviews?.length > 0 && (
                      <Rate
                        disabled
                        allowHalf
                        style={{ paddingBottom: 10 }}
                        defaultValue={Math.round(
                          Number(
                            newReviews[
                              newReviews.length - 1
                            ].percentage.media.toFixed(2),
                          ),
                        )}
                      />
                    )}
                    {!newReviews?.length && (
                      <Rate
                        disabled
                        allowHalf
                        style={{ paddingBottom: 10 }}
                        defaultValue={Math.round(
                          Number(
                            reviews?.data[0]?.percentage?.media.toFixed(2),
                          ),
                        )}
                      />
                    )}
                    <p>
                      <StaticIntlTranslator id="common:assessments" />
                    </p>
                  </div>

                  <div className="rate-rows-container">
                    {Array(5)
                      .fill(1)
                      .map((el, index, array) => {
                        const reversedIndex = array.length - index;

                        return (
                          <button
                            type="button"
                            key={`rate-row-${index}`}
                            className="rate-filter-btn"
                            onClick={() =>
                              handleRateFilter(reversedIndex, index)
                            }
                          >
                            <div className="rate-row">
                              <div className="progress-bar-col">
                                <Progress
                                  strokeColor={{
                                    "0%": "#108ee9",
                                    "100%": "#87d068",
                                  }}
                                  percent={
                                    newReviews?.length > 0
                                      ? newReviews[newReviews.length - 1]
                                          .percentage[reversedIndex]
                                      : reviews?.data[0]?.percentage[
                                          reversedIndex
                                        ]
                                  }
                                />
                              </div>

                              <div className="rate-col">
                                <Rate
                                  disabled
                                  allowHalf
                                  defaultValue={reversedIndex}
                                />

                                <div className="mobile-rate">
                                  <p>{reversedIndex}</p>
                                  <StarFilled style={{ color: "#fbdb14" }} />
                                </div>
                              </div>

                              <div className="badge-col">
                                <Badge
                                  // style={{ backgroundColor: "#108ee9" }}
                                  count={
                                    newReviews?.length > 0
                                      ? newReviews[newReviews.length - 1].total[
                                          reversedIndex
                                        ]
                                      : reviews?.data[0]?.total[reversedIndex]
                                  }
                                />
                              </div>
                            </div>
                          </button>
                        );
                      })}
                  </div>
                </div>
              </Content>
            )}
          </>

          {userCanRead && (
            <Assessments
              entityId={entityId}
              contentType={contentType}
              hasReviewed={hasReviewed}
              writeStatus={writeStatus}
              hasEnrollment={hasEnrollment}
              startEnrollment={startEnrollment}
              rateFilter={rateFilter && rateFilter}
              completePercentage={completePercentage}
            />
          )}
        </Widget>
      </Container>
    </>
  );
};

Feedback.defaultProps = {
  sectionTitle: "Feedbacks",
};

Feedback.propTypes = {
  sectionTitle: PropTypes.string,
  hideTitle: PropTypes.any.isRequired,
};

export default Feedback;
